// This will remove any non valid character into the numeric expression
const whitespaceRegex = /[^\d+.-]/gi;

export function normalizeNumberAsString(str: string): string {
  return str.replaceAll(whitespaceRegex, "");
}

export function convertNumericStringToNumber(str: string | undefined): number {
  return +normalizeNumberAsString(str || "");
}

export function generateRandomString(seedString: string, seedNumber: number, stringLength = 5) {
  const randomChars: string[] = [];
  let seed = 0;
  for (let i = 0; i < seedString.length; i++) {
    seed += seedString.charCodeAt(i);
  }
  seed += seedNumber;
  for (let i = 0; i < stringLength; i++) {
    // generating a random number between 0 and 0xffffffff, the maximum value of a 32-bit unsigned integer
    let randomNumber = ((Math.sin(seed + i) * 0xffffffff) >>> 0) % 62;
    randomNumber += randomNumber < 10 ? 48 : randomNumber < 36 ? 55 : 61;
    randomChars.push(String.fromCharCode(randomNumber));
  }
  return randomChars.join("");
}
